import { render, staticRenderFns } from "./Cave.vue?vue&type=template&id=73e05c21&"
import script from "./Cave.vue?vue&type=script&lang=js&"
export * from "./Cave.vue?vue&type=script&lang=js&"
import style0 from "./Cave.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports